const orderStatusData = import('@/assets/data/order_status.json');

export const orderBookHelpers = {
    renderPrice,
    renderOrderStatusFilter,
    getStatusList,
    renderOrderTypeM,
}

function renderPrice(orderType, timeInForce) {
    switch (orderType) {
        case 'R': return 'MTL';
        case 'C': return 'ATC';
        case 'O': return 'ATO';
        case 'J': return 'PLO';
        case 'M': {
            if (timeInForce) {
                return (timeInForce === '3' || timeInForce === 'IOC') ? 'MAK' :
                    (timeInForce === '4' || timeInForce === 'FOK') ? 'MOK' :
                        (timeInForce === '0' || timeInForce === 'DAY') ? 'MP' : 'MO';
            }
            else {
                return 'MO';
            }
        }
        default: return orderType;
    }
}

async function getStatusList(statusMaster) {
    const orderStatus = await orderStatusData
    const statusList = orderStatus[statusMaster]
    return statusList ? Object.keys(statusList) : []
    // const statusGroup = new Map()
    // const statusList = orderStatus[master]
    // if(statusList) {
    //     for (const [key, value] of Object.entries(statusList)) {
    //         const snakeCaseString = `order_status_${convertToSnakeCase(value)}`
    //         if (statusGroup.has(snakeCaseString)) {
    //             const list = statusGroup.get(snakeCaseString)
    //             list.push(key)
    //             statusGroup.set(snakeCaseString, list)
    //         } else {
    //             statusGroup.set(snakeCaseString, [key])
    //         }
    //     }
    //     const dropDownOptions = []
    //     for (let key of statusGroup.keys()) {
    //         dropDownOptions.push({ label: key, value: key })
    //     }
    //     return {
    //         options: dropDownOptions,
    //         data: statusGroup
    //     }
    // }
}

async function renderOrderStatusFilter(master) {
    const orderStatus = await orderStatusData
    const statusGroup = new Map()
    const statusList = orderStatus[master]
    if(statusList) {
        for (const [key, value] of Object.entries(statusList)) {
            const snakeCaseString = `order_status_${convertToSnakeCase(value)}`
            if (statusGroup.has(snakeCaseString)) {
                const list = statusGroup.get(snakeCaseString)
                list.push(key)
                statusGroup.set(snakeCaseString, list)
            } else {
                statusGroup.set(snakeCaseString, [key])
            }
        }
        const dropDownOptions = []
        for (let key of statusGroup.keys()) {
            dropDownOptions.push({ label: key, value: key })
        }
        return {
            options: dropDownOptions,
            data: statusGroup
        }
    }
}

function convertToSnakeCase(str) {
    return str && str.match(
        /[A-Z]{2,}(?=[A-Z][a-z]+[0-9]*|\b)|[A-Z]?[a-z]+[0-9]*|[A-Z]|[0-9]+/g)
        .map(s => s.toLowerCase())
        .join('_');
}

function renderOrderTypeM(timeInForce) {
    let result = 'M'
    if (timeInForce) {
        return (timeInForce === '3' || timeInForce === 'IOC') ? 'Z' :
            (timeInForce === '4' || timeInForce === 'FOK') ? 'B' :
                (timeInForce === '0' || timeInForce === 'DAY') ? 'M' : 'M';
    }
    return result
}